import { GhostProvider } from './../../providers/ghost/ghost';
import { Post } from './../../models/ghost/Post';
import { ViewController, LoadingController } from 'ionic-angular';
import { Component } from '@angular/core';

/**
 * Generated class for the HelpComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'help',
  templateUrl: 'help.html'
})
export class HelpComponent {

  slug: string;
  title: string;

  post: Post;
  content: string;

  constructor(
    private viewCtrl: ViewController,
    private ghost: GhostProvider,
    private loadingCtrl: LoadingController
  ) {
    this.slug = this.viewCtrl.getNavParams().get('slug');
    this.title = this.viewCtrl.getNavParams().get('title');

    let loader = this.loadingCtrl.create();
    loader.present();
    this.ghost.getPostBySlug(this.slug).subscribe(post => {
      this.post = post;
      this.content = this.post.html;
      if(!this.title){
        this.title = post.title;
      }
      loader.dismiss();
    }, error => {
      console.log(error);
      loader.dismiss();
    })

  }

  dismiss(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/help/help.ts